var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6335",
    "data-name": "Groupe 6335",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 705.252,
    height: 525.566,
    viewBox: "0 0 705.252 525.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3486",
    "data-name": "Rectangle 3486",
    width: 705.252,
    height: 525.567,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3471",
    "data-name": "Rectangle 3471",
    width: 25.069,
    height: 33.696,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3472",
    "data-name": "Rectangle 3472",
    width: 8.143,
    height: 27.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3473",
    "data-name": "Rectangle 3473",
    width: 13.197,
    height: 15.225,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3474",
    "data-name": "Rectangle 3474",
    width: 21.197,
    height: 18.492,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3475",
    "data-name": "Rectangle 3475",
    width: 68.594,
    height: 80.671,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3476",
    "data-name": "Rectangle 3476",
    width: 8.813,
    height: 11.466,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3477",
    "data-name": "Rectangle 3477",
    width: 17.346,
    height: 95.731,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3478",
    "data-name": "Rectangle 3478",
    width: 25.701,
    height: 34.129,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3479",
    "data-name": "Rectangle 3479",
    width: 55.551,
    height: 5.753,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3480",
    "data-name": "Rectangle 3480",
    width: 259.341,
    height: 259.327,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3481",
    "data-name": "Rectangle 3481",
    width: 131.686,
    height: 233.072,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3482",
    "data-name": "Rectangle 3482",
    width: 152.855,
    height: 250.349,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3484",
    "data-name": "Rectangle 3484",
    width: 426.683,
    height: 259.465,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6334",
    "data-name": "Groupe 6334",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3444",
    "data-name": "Rectangle 3444",
    width: 705.252,
    height: 0.353,
    transform: "translate(0 461.864)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3445",
    "data-name": "Rectangle 3445",
    width: 46.719,
    height: 0.353,
    transform: "translate(587.869 484.568)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3446",
    "data-name": "Rectangle 3446",
    width: 99.874,
    height: 0.353,
    transform: "translate(470.236 484.568)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3447",
    "data-name": "Rectangle 3447",
    width: 27.072,
    height: 0.353,
    transform: "translate(388.088 471.47)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3448",
    "data-name": "Rectangle 3448",
    width: 48.366,
    height: 0.353,
    transform: "translate(73.994 473.839)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3449",
    "data-name": "Rectangle 3449",
    width: 87.942,
    height: 0.353,
    transform: "translate(134.918 473.839)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3450",
    "data-name": "Rectangle 3450",
    width: 51.926,
    height: 0.351,
    transform: "translate(265.645 479.796)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6288",
    "data-name": "Groupe 6288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6287",
    "data-name": "Groupe 6287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5587",
    "data-name": "Trac\\xE9 5587",
    d: "M318.625,398.957H46.258a8.06,8.06,0,0,1-8.051-8.051V8.051A8.061,8.061,0,0,1,46.258,0H318.625a8.061,8.061,0,0,1,8.05,8.051V390.906a8.06,8.06,0,0,1-8.05,8.051M46.258.353a7.706,7.706,0,0,0-7.7,7.7V390.906a7.706,7.706,0,0,0,7.7,7.7H318.625a7.707,7.707,0,0,0,7.7-7.7V8.051a7.707,7.707,0,0,0-7.7-7.7Z",
    transform: "translate(15.684)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5588",
    "data-name": "Trac\\xE9 5588",
    d: "M534.922,398.957H262.555a8.059,8.059,0,0,1-8.05-8.051V8.051A8.06,8.06,0,0,1,262.555,0H534.922a8.061,8.061,0,0,1,8.051,8.051V390.906a8.06,8.06,0,0,1-8.051,8.051M262.555.353a7.706,7.706,0,0,0-7.7,7.7V390.906a7.706,7.706,0,0,0,7.7,7.7H534.922a7.707,7.707,0,0,0,7.7-7.7V8.051a7.707,7.707,0,0,0-7.7-7.7Z",
    transform: "translate(104.476)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3451",
    "data-name": "Rectangle 3451",
    width: 191.404,
    height: 165.834,
    transform: "translate(106.963 29.196)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3452",
    "data-name": "Rectangle 3452",
    width: 191.404,
    height: 165.834,
    transform: "translate(102.71 29.196)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3453",
    "data-name": "Rectangle 3453",
    width: 176.134,
    height: 153.982,
    transform: "translate(110.345 35.122)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5589",
    "data-name": "Trac\\xE9 5589",
    d: "M172.451,178.882,204.362,24.9H137.6L105.689,178.882Z",
    transform: "translate(43.386 10.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3454",
    "data-name": "Rectangle 3454",
    width: 3.216,
    height: 153.982,
    transform: "translate(110.344 35.122)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3455",
    "data-name": "Rectangle 3455",
    width: 185.088,
    height: 7.957,
    transform: "translate(105.868 153.536)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3456",
    "data-name": "Rectangle 3456",
    width: 30.563,
    height: 132.548,
    transform: "translate(289.5 320.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3457",
    "data-name": "Rectangle 3457",
    width: 224.314,
    height: 8.398,
    transform: "translate(89.882 453.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3458",
    "data-name": "Rectangle 3458",
    width: 205.488,
    height: 132.548,
    transform: "translate(84.012 320.918)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3459",
    "data-name": "Rectangle 3459",
    width: 181.456,
    height: 43.472,
    transform: "translate(96.029 337.231)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3460",
    "data-name": "Rectangle 3460",
    width: 181.456,
    height: 43.472,
    transform: "translate(96.029 393.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5590",
    "data-name": "Trac\\xE9 5590",
    d: "M98.6,258.344h97.81a2.981,2.981,0,0,0,0-5.962H98.6a2.981,2.981,0,0,0,0,5.962",
    transform: "translate(39.252 103.604)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5591",
    "data-name": "Trac\\xE9 5591",
    d: "M98.6,298.363h97.81a2.981,2.981,0,0,0,0-5.962H98.6a2.981,2.981,0,0,0,0,5.962",
    transform: "translate(39.252 120.032)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5592",
    "data-name": "Trac\\xE9 5592",
    d: "M437.627,96.488c17.406-4.8,23.359-36.376-20.627-49.266,9.7,31.756-9.72,57.629,20.627,49.266",
    transform: "translate(171.181 19.385)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5593",
    "data-name": "Trac\\xE9 5593",
    d: "M448.52,102.894c13.716-14.83.742-48.362-48.679-34.663C427.8,92.7,424.607,128.75,448.52,102.894",
    transform: "translate(164.137 26.687)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5594",
    "data-name": "Trac\\xE9 5594",
    d: "M425.8,105.442c-11.486-11.37,4.965-50.931,42.879-32.6-21.485,20.541-22.854,52.419-42.879,32.6",
    transform: "translate(173.314 27.943)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5595",
    "data-name": "Trac\\xE9 5595",
    d: "M417.368,116.849h33.413L453.3,94.242H414.846Z",
    transform: "translate(170.296 38.687)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5596",
    "data-name": "Trac\\xE9 5596",
    d: "M415.305,98.559h39.209a2.494,2.494,0,1,0,0-4.989H415.305a2.494,2.494,0,1,0,0,4.989",
    transform: "translate(169.461 38.411)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5597",
    "data-name": "Trac\\xE9 5597",
    d: "M226.592,378.307h0V340.016h31.9V301.725h31.9v-38.29h31.9V225.143h31.9V186.852h31.9V148.561h31.9V110.27H625.329V416.6H194.693V378.307Z",
    transform: "translate(79.923 45.266)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5598",
    "data-name": "Trac\\xE9 5598",
    d: "M350.976,378.307h0V340.016h31.9V301.725h31.9v-38.29h31.9V225.143h31.9V186.852h31.9V148.561h31.9V110.27h31.9V416.6H319.078V378.307Z",
    transform: "translate(130.983 45.266)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3461",
    "data-name": "Rectangle 3461",
    width: 177.324,
    height: 11.487,
    transform: "translate(272.737 423.573)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3462",
    "data-name": "Rectangle 3462",
    width: 177.324,
    height: 11.487,
    transform: "translate(304.635 385.282)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3463",
    "data-name": "Rectangle 3463",
    width: 177.324,
    height: 11.487,
    transform: "translate(336.534 346.991)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3464",
    "data-name": "Rectangle 3464",
    width: 177.324,
    height: 11.487,
    transform: "translate(368.432 308.7)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3465",
    "data-name": "Rectangle 3465",
    width: 177.324,
    height: 11.487,
    transform: "translate(400.332 270.409)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3466",
    "data-name": "Rectangle 3466",
    width: 177.324,
    height: 11.487,
    transform: "translate(432.231 232.118)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3467",
    "data-name": "Rectangle 3467",
    width: 177.324,
    height: 11.487,
    transform: "translate(464.129 193.827)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    width: 177.324,
    height: 11.487,
    transform: "translate(496.029 155.536)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6290",
    "data-name": "Groupe 6290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6289",
    "data-name": "Groupe 6289",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5599",
    "data-name": "Trac\\xE9 5599",
    d: "M603.074,365.934c0,8.821-122.442,15.971-273.481,15.971s-273.481-7.15-273.481-15.971,122.442-15.971,273.481-15.971,273.481,7.151,273.481,15.971",
    transform: "translate(23.034 143.662)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6328",
    "data-name": "Groupe 6328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6327",
    "data-name": "Groupe 6327",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5600",
    "data-name": "Trac\\xE9 5600",
    d: "M350.031,103.9c-.243,4.227-.738,8.113-1.289,12.136-.554,3.99-1.3,7.95-2.151,11.9a132.355,132.355,0,0,1-7.122,23.376l-1.274,2.845-.319.71-.159.355c-.052.114-.094.216-.217.451a11.218,11.218,0,0,1-1.628,2.447,9.494,9.494,0,0,1-2.7,2.133,9.361,9.361,0,0,1-3.222,1.013,12.166,12.166,0,0,1-5.122-.533,24.971,24.971,0,0,1-6.543-3.377,55.815,55.815,0,0,1-5.013-4.019,116.654,116.654,0,0,1-15.939-18.246l4.681-3.956c2.746,2.607,5.615,5.239,8.479,7.739a112.239,112.239,0,0,0,8.779,7.048,45.7,45.7,0,0,0,4.453,2.883,15.138,15.138,0,0,0,3.979,1.7c.489.1.825.044.67.01a1.535,1.535,0,0,0-.9.4c-.082.073-.085.066-.062-.02l.453-1.179.986-2.563a151.2,151.2,0,0,0,5.717-21.66c.74-3.7,1.267-7.459,1.825-11.2.535-3.715.963-7.594,1.286-11.16Z",
    transform: "translate(122.057 42.334)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5601",
    "data-name": "Trac\\xE9 5601",
    d: "M331.238,92.923c-5.257,1.339-8.934,22.97-8.934,22.97l14.486,9.852s13.889-21.823,9.845-27.6c-4.212-6.019-7.727-7.172-15.4-5.219",
    transform: "translate(132.307 37.787)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5602",
    "data-name": "Trac\\xE9 5602",
    d: "M331.238,92.923c-5.257,1.339-8.934,22.97-8.934,22.97l14.486,9.852s13.889-21.823,9.845-27.6c-4.212-6.019-7.727-7.172-15.4-5.219",
    transform: "translate(132.307 37.787)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6293",
    "data-name": "Groupe 6293",
    transform: "translate(454.611 129.837)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6292",
    "data-name": "Groupe 6292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6291",
    "data-name": "Groupe 6291",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5603",
    "data-name": "Trac\\xE9 5603",
    d: "M331.238,92.923c-5.257,1.339-8.934,22.97-8.934,22.97l14.486,9.852s13.889-21.823,9.845-27.6c-4.212-6.019-7.727-7.172-15.4-5.219",
    transform: "translate(-322.304 -92.05)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6296",
    "data-name": "Groupe 6296",
    transform: "translate(459.981 135.541)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6295",
    "data-name": "Groupe 6295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6294",
    "data-name": "Groupe 6294",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5604",
    "data-name": "Trac\\xE9 5604",
    d: "M330.15,96.094l-4.038,21.8,8.141,5.521Z",
    transform: "translate(-326.111 -96.094)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5605",
    "data-name": "Trac\\xE9 5605",
    d: "M303.989,125.5l-6.89-10.883-3.908,12.367s5.652,5.928,10.762,4.515Z",
    transform: "translate(120.356 47.051)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5606",
    "data-name": "Trac\\xE9 5606",
    d: "M289.589,112.065,286.877,122.6l8.9,5.436,3.907-12.367Z",
    transform: "translate(117.765 46.003)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5607",
    "data-name": "Trac\\xE9 5607",
    d: "M352.761,359.4H340.007l-.852-29.536h12.754Z",
    transform: "translate(139.225 135.41)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5608",
    "data-name": "Trac\\xE9 5608",
    d: "M437.9,314.58l-9.721,8.257L405.93,302.981l9.721-8.258Z",
    transform: "translate(166.636 120.985)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5609",
    "data-name": "Trac\\xE9 5609",
    d: "M421.222,317.2l9.428-10.79a1.009,1.009,0,0,1,1.326-.195l9.611,6.23a2.049,2.049,0,0,1,.362,3.033c-3.351,3.706-5.155,5.325-9.3,10.071-2.55,2.918-5.973,7.449-9.5,11.48-3.444,3.944-7.7.765-6.591-1.23,4.958-8.941,3.763-12.081,3.849-16.477a3.329,3.329,0,0,1,.813-2.121",
    transform: "translate(170.927 125.634)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5610",
    "data-name": "Trac\\xE9 5610",
    d: "M345.476,349.756h14.329a1.01,1.01,0,0,1,1.017.872l1.633,11.336a2.048,2.048,0,0,1-2.045,2.268c-5-.086-7.4-.379-13.7-.379-3.876,0-11.895.4-17.249.4-5.236,0-5.638-5.294-3.409-5.773,10-2.15,13.929-5.114,17.3-7.943a3.323,3.323,0,0,1,2.131-.784",
    transform: "translate(133.318 143.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6299",
    "data-name": "Groupe 6299",
    transform: "translate(478.383 465.281)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6298",
    "data-name": "Groupe 6298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6297",
    "data-name": "Groupe 6297",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5611",
    "data-name": "Trac\\xE9 5611",
    d: "M339.157,329.868l.437,15.225h12.759l-.437-15.225Z",
    transform: "translate(-339.157 -329.868)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6302",
    "data-name": "Groupe 6302",
    transform: "translate(572.57 415.712)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6301",
    "data-name": "Groupe 6301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6300",
    "data-name": "Groupe 6300",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5612",
    "data-name": "Trac\\xE9 5612",
    d: "M415.657,294.726l-9.725,8.261,11.473,10.23,9.724-8.261Z",
    transform: "translate(-405.933 -294.726)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5613",
    "data-name": "Trac\\xE9 5613",
    d: "M329.079,93.744s-6.076,2.14,6.095,76.978h51.8c-.869-21.081-.894-34.082,9.182-77.348a152.906,152.906,0,0,0-22-2.9c-8.717-.42-15.858-.7-23.521,0-10.1.921-21.56,3.267-21.56,3.267",
    transform: "translate(134.466 36.966)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6305",
    "data-name": "Groupe 6305",
    transform: "translate(462.029 127.017)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6304",
    "data-name": "Groupe 6304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6303",
    "data-name": "Groupe 6303",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5614",
    "data-name": "Trac\\xE9 5614",
    d: "M329.079,93.744s-6.076,2.14,6.095,76.978h51.8c-.869-21.081-.894-34.082,9.182-77.348a152.906,152.906,0,0,0-22-2.9c-8.717-.42-15.858-.7-23.521,0-10.1.921-21.56,3.267-21.56,3.267",
    transform: "translate(-327.563 -90.051)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5615",
    "data-name": "Trac\\xE9 5615",
    d: "M368.88,90.468c-8.717-.409-15.854-.691-23.527.014-1.269.113-2.567.254-3.851.409a6.27,6.27,0,0,0-.705,5.5c1.65,4.1,7.6,4.584,11.947,4.584,16.037,0,18.746-9.366,18.858-9.761l.155-.564c-.959-.071-1.918-.141-2.877-.183",
    transform: "translate(139.748 36.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5616",
    "data-name": "Trac\\xE9 5616",
    d: "M365.727,71.575c-1.484,7.569-2.965,21.435,2.33,26.485,0,0-2.069,7.677-16.131,7.677-15.463,0-7.391-7.676-7.391-7.676,8.44-2.016,8.222-8.277,6.752-14.157Z",
    transform: "translate(140.569 29.382)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6308",
    "data-name": "Groupe 6308",
    transform: "translate(491.863 105.988)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6307",
    "data-name": "Groupe 6307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6306",
    "data-name": "Groupe 6306",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5617",
    "data-name": "Trac\\xE9 5617",
    d: "M357.26,75.142l-8.546,7.291a24.191,24.191,0,0,1,.725,4.176c3.224-.467,7.653-4.006,8-7.381a11.322,11.322,0,0,0-.175-4.086",
    transform: "translate(-348.714 -75.142)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5618",
    "data-name": "Trac\\xE9 5618",
    d: "M352.986,54.335c-1.313-4.433-2.444-11.439,5.48-14.534-3.083-3.779-3.838-10.889-.049-15.114S368,22.026,368,22.026s1.691-10.311,14.229-8.507,6.954,10.106,6.954,10.106,17.112-3.389,18.255,12.731-8.682,14.132-8.682,14.132,7.634,6.4,3.408,13.438-14.009,4.614-14.009,4.614-4.6,12.436-15.427,5.36-19.747-19.565-19.747-19.565",
    transform: "translate(144.519 5.463)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5619",
    "data-name": "Trac\\xE9 5619",
    d: "M335.4,51.444c-4.241,5.463-2.368,11.663,1.371,14.053,9.1,5.811,22.256-18.55,18.836-21.471s-15.966,1.955-20.207,7.418",
    transform: "translate(136.688 17.714)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5620",
    "data-name": "Trac\\xE9 5620",
    d: "M366.038,40.086c-5.985-2.412-12.043.107-13.939,3.752-4.615,8.869,16.332,24.854,22.4,13.762,3.6-6.586-2.292-15.028-8.46-17.514",
    transform: "translate(144.268 16.065)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5621",
    "data-name": "Trac\\xE9 5621",
    d: "M370.33,63.943c.433,12.651.887,18-4.847,25.06-8.624,10.627-24.258,8.391-28.461-3.875-3.784-11.041-3.858-29.874,7.974-36.06A17.264,17.264,0,0,1,370.33,63.943",
    transform: "translate(137.421 19.305)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5622",
    "data-name": "Trac\\xE9 5622",
    d: "M368.021,73.262c-5.6-2.1-7.06-8.689-6.139-11.222-2.8-.118-8.995-1.126-11.314-4.629-4.4,2.766-13.695,5.632-14.707.952s13.032-16.778,23.634-17.7c12.6-1.1,25.055,11.3,21.839,23.151s-13.314,9.453-13.314,9.453",
    transform: "translate(137.851 16.662)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5623",
    "data-name": "Trac\\xE9 5623",
    d: "M335.658,147.244s-10.06,98.249-9.225,137.143c.87,40.456,15.695,132.724,15.695,132.724h17.246s-2.729-89.9-1.2-129.637c1.662-43.314,15.421-140.231,15.421-140.231Z",
    transform: "translate(133.982 60.444)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5624",
    "data-name": "Trac\\xE9 5624",
    d: "M357.154,341.118H336.919l-1.485-6.454,22.661-.79Z",
    transform: "translate(137.697 137.057)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6311",
    "data-name": "Groupe 6311",
    transform: "translate(485.812 226.057)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6310",
    "data-name": "Groupe 6310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6309",
    "data-name": "Groupe 6309",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5625",
    "data-name": "Trac\\xE9 5625",
    d: "M350.6,166.344c-12.723,25.594-2.554,72.284,1.945,89.655,2.308-26.089,6.2-57.979,9.229-81.4-1.928-13.25-5.306-20.057-11.174-8.257",
    transform: "translate(-344.424 -160.267)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5626",
    "data-name": "Trac\\xE9 5626",
    d: "M342.658,147.244s11.734,102.142,20.595,134.935c10.521,38.931,75.871,91.327,75.871,91.327l13.256-11.26s-47.365-56.917-55.409-77.427C379.8,241.045,394.5,175.81,380.778,147.244Z",
    transform: "translate(140.663 60.444)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5627",
    "data-name": "Trac\\xE9 5627",
    d: "M428.52,301.287l-16.445,13.968-6.143-3.681,18.6-17.3Z",
    transform: "translate(166.637 120.799)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5628",
    "data-name": "Trac\\xE9 5628",
    d: "M347.4,63.316c.1,1.024-.365,1.907-1.034,1.97s-1.293-.714-1.392-1.738.365-1.907,1.035-1.97,1.291.714,1.391,1.738",
    transform: "translate(141.609 25.277)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5629",
    "data-name": "Trac\\xE9 5629",
    d: "M339.2,64.1c.1,1.024-.365,1.907-1.034,1.97s-1.292-.714-1.391-1.738.365-1.907,1.035-1.97,1.291.714,1.389,1.738",
    transform: "translate(138.241 25.6)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5630",
    "data-name": "Trac\\xE9 5630",
    d: "M338.45,62.522l-2.528-.473s1.446,1.8,2.528.473",
    transform: "translate(137.898 25.471)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5631",
    "data-name": "Trac\\xE9 5631",
    d: "M341.655,64.635s-1.315,4.576-3.024,6.886c1.473,1.133,3.717.334,3.717.334Z",
    transform: "translate(139.01 26.533)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5632",
    "data-name": "Trac\\xE9 5632",
    d: "M345.894,73.387a9.873,9.873,0,0,1-1.7.313.3.3,0,0,1-.056-.6,8.138,8.138,0,0,0,6.309-3.8.3.3,0,0,1,.536.279,8.437,8.437,0,0,1-5.085,3.814",
    transform: "translate(141.156 28.378)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5633",
    "data-name": "Trac\\xE9 5633",
    d: "M364.683,66.7a9.256,9.256,0,0,1-3.5,6.141c-2.576,1.972-5.064-.042-5.354-3.1-.261-2.755.764-7.1,3.834-7.871,3.024-.759,5.363,1.851,5.016,4.831",
    transform: "translate(146.055 25.344)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5634",
    "data-name": "Trac\\xE9 5634",
    d: "M349.225,58.254a.61.61,0,0,1-.473-.063,4.808,4.808,0,0,0-4.343-.427.6.6,0,1,1-.529-1.088,5.994,5.994,0,0,1,5.494.478.6.6,0,0,1-.15,1.1",
    transform: "translate(141.025 23.081)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5635",
    "data-name": "Trac\\xE9 5635",
    d: "M334.694,61.35a.6.6,0,0,1-.694-.867,5.992,5.992,0,0,1,4.471-3.227.6.6,0,0,1,.106,1.2,4.776,4.776,0,0,0-3.512,2.594.6.6,0,0,1-.371.3",
    transform: "translate(137.079 23.503)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5636",
    "data-name": "Trac\\xE9 5636",
    d: "M385.081,102.162a202.607,202.607,0,0,1,7.426,21.526,134.159,134.159,0,0,1,4.68,22.623c.241,1.946.309,3.985.4,6l.009.189v.315l-.018.652c-.03.409-.066.825-.128,1.195a15.272,15.272,0,0,1-.475,2.092,20.9,20.9,0,0,1-1.389,3.4,49.555,49.555,0,0,1-7.147,10,121.388,121.388,0,0,1-16.884,15.408l-4.133-4.526c4.7-5.48,9.448-11.115,13.458-16.872a46.558,46.558,0,0,0,4.942-8.521,12.23,12.23,0,0,0,.557-1.789,3.389,3.389,0,0,0,.079-.621,1.171,1.171,0,0,0-.006-.185c0-.023-.013-.027-.014-.041l-.021-.189c-.183-1.671-.316-3.326-.629-5.035a155.487,155.487,0,0,0-5.058-20.584c-2.161-6.821-4.57-13.757-7.108-20.348Z",
    transform: "translate(150.83 41.938)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5637",
    "data-name": "Trac\\xE9 5637",
    d: "M380.349,92.49c5.189,1.578,11.422,19.448,11.422,19.448l-20.134,14.4s-7.343-14.918-5.162-21.626c2.271-6.986,7.951-14.019,13.874-12.218",
    transform: "translate(150.274 37.85)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6314",
    "data-name": "Groupe 6314",
    transform: "translate(516.345 130.056)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6313",
    "data-name": "Groupe 6313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6312",
    "data-name": "Groupe 6312",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5638",
    "data-name": "Trac\\xE9 5638",
    d: "M380.349,92.49c5.189,1.578,11.422,19.448,11.422,19.448l-20.134,14.4s-7.343-14.918-5.162-21.626c2.271-6.986,7.951-14.019,13.874-12.218",
    transform: "translate(-366.071 -92.205)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5639",
    "data-name": "Trac\\xE9 5639",
    d: "M417.819,319.681a1.763,1.763,0,0,1-1.348-.69,1.031,1.031,0,0,1-.244-1.011c.471-1.559,4.9-2.831,5.406-2.971a.3.3,0,0,1,.347.432c-.791,1.5-2.361,4.045-3.971,4.23a1.731,1.731,0,0,1-.19.01m3.274-3.88c-1.758.56-4.04,1.535-4.287,2.354a.428.428,0,0,0,.123.441,1.142,1.142,0,0,0,1.013.474c.869-.1,2.024-1.306,3.151-3.27",
    transform: "translate(170.845 129.308)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5640",
    "data-name": "Trac\\xE9 5640",
    d: "M419.806,316.5c-1.47,0-3.123-.3-3.69-1.032a1.055,1.055,0,0,1,.034-1.32,1.572,1.572,0,0,1,1.145-.7c1.829-.234,4.614,2.167,4.732,2.27a.3.3,0,0,1-.1.512,7.064,7.064,0,0,1-2.121.268m-2.24-2.463a1.442,1.442,0,0,0-.193.013.979.979,0,0,0-.722.437c-.219.322-.144.5-.056.612.546.708,3.054.979,4.58.7-.911-.709-2.511-1.766-3.608-1.766",
    transform: "translate(170.73 128.665)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5641",
    "data-name": "Trac\\xE9 5641",
    d: "M337.115,352.277a4.781,4.781,0,0,1-3.092-.786,1.671,1.671,0,0,1-.546-1.47.969.969,0,0,1,.512-.8c1.563-.858,6.646,1.741,7.22,2.04a.3.3,0,0,1,.161.31.3.3,0,0,1-.241.254,21.784,21.784,0,0,1-4.014.456m-2.272-2.639a1.191,1.191,0,0,0-.564.11.374.374,0,0,0-.2.327,1.086,1.086,0,0,0,.348.968c.774.7,2.875.818,5.7.347a16.436,16.436,0,0,0-5.284-1.752",
    transform: "translate(136.89 143.284)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5642",
    "data-name": "Trac\\xE9 5642",
    d: "M340.147,352.7a.294.294,0,0,1-.124-.027c-1.521-.687-4.528-3.437-4.292-4.882.056-.343.3-.767,1.135-.852a2.2,2.2,0,0,1,1.673.52c1.6,1.336,1.9,4.769,1.909,4.914a.3.3,0,0,1-.3.326m-3.038-5.169a1.581,1.581,0,0,0-.182.01c-.552.055-.588.276-.6.348-.142.867,1.9,3.031,3.449,3.969-.148-1-.573-3.058-1.625-3.934a1.582,1.582,0,0,0-1.042-.394",
    transform: "translate(137.814 142.415)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5643",
    "data-name": "Trac\\xE9 5643",
    d: "M386,145.2l1.324,4.636c.182.36-.244.726-.844.726H333.171c-.467,0-.853-.228-.883-.522l-.467-4.636c-.032-.322.372-.594.883-.594H385.16a.942.942,0,0,1,.844.389",
    transform: "translate(136.214 59.446)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6317",
    "data-name": "Groupe 6317",
    transform: "translate(468.032 204.259)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6316",
    "data-name": "Groupe 6316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6315",
    "data-name": "Groupe 6315",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5644",
    "data-name": "Trac\\xE9 5644",
    d: "M386,145.2l1.324,4.636c.182.36-.244.726-.844.726H333.171c-.467,0-.853-.228-.883-.522l-.467-4.636c-.032-.322.372-.594.883-.594H385.16a.942.942,0,0,1,.844.389",
    transform: "translate(-331.819 -144.813)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5645",
    "data-name": "Trac\\xE9 5645",
    d: "M365.59,151.188h1.4c.279,0,.492-.144.474-.32l-.659-6.024c-.02-.176-.264-.32-.544-.32h-1.4c-.279,0-.492.144-.474.32l.66,6.024c.018.176.264.32.543.32",
    transform: "translate(149.582 59.327)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5646",
    "data-name": "Trac\\xE9 5646",
    d: "M335.927,151.188h1.4c.279,0,.492-.144.474-.32l-.659-6.024c-.02-.176-.264-.32-.544-.32h-1.4c-.279,0-.492.144-.474.32l.66,6.024c.018.176.264.32.543.32",
    transform: "translate(137.406 59.327)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5647",
    "data-name": "Trac\\xE9 5647",
    d: "M350.758,151.188h1.4c.279,0,.494-.144.474-.32l-.659-6.024c-.02-.176-.264-.32-.544-.32h-1.4c-.279,0-.492.144-.474.32l.66,6.024c.018.176.264.32.543.32",
    transform: "translate(143.494 59.327)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5648",
    "data-name": "Trac\\xE9 5648",
    d: "M346.657,61.735l-2.528-.474s1.446,1.8,2.528.474",
    transform: "translate(141.267 25.148)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6320",
    "data-name": "Groupe 6320",
    transform: "translate(264.612 16.015)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6319",
    "data-name": "Groupe 6319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6318",
    "data-name": "Groupe 6318",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5649",
    "data-name": "Trac\\xE9 5649",
    d: "M364.22,261.843A129.627,129.627,0,1,1,438.1,94.058,129.628,129.628,0,0,1,364.22,261.843",
    transform: "translate(-187.601 -11.354)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6323",
    "data-name": "Groupe 6323",
    transform: "translate(286.086 16.025)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6322",
    "data-name": "Groupe 6322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6321",
    "data-name": "Groupe 6321",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5650",
    "data-name": "Trac\\xE9 5650",
    d: "M334.512,13.523,232.848,244.434c-1.573-1.186-3.116-2.413-4.636-3.665a127.871,127.871,0,0,1-25.382-28.326l-.006-.013,87.81-199.443a128.615,128.615,0,0,1,43.878.535",
    transform: "translate(-202.825 -11.361)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6326",
    "data-name": "Groupe 6326",
    transform: "translate(337.192 24.989)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6325",
    "data-name": "Groupe 6325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6324",
    "data-name": "Groupe 6324",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5651",
    "data-name": "Trac\\xE9 5651",
    d: "M391.913,50.981,296.326,268.065a129.5,129.5,0,0,1-57.268-13.284L343.431,17.717a129.672,129.672,0,0,1,48.482,33.264",
    transform: "translate(-239.058 -17.716)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5652",
    "data-name": "Trac\\xE9 5652",
    d: "M212.96,56.081a137.886,137.886,0,1,1,19.373,194.045A137.891,137.891,0,0,1,212.96,56.081M417.653,223.594A126.614,126.614,0,1,0,239.47,241.4a126.614,126.614,0,0,0,178.184-17.809",
    transform: "translate(74.618 2.266)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5653",
    "data-name": "Trac\\xE9 5653",
    d: "M361.226,160.121c13.582,8.11,26.5,17.029,39.2,26.221s25.066,18.784,37.247,28.606,24.114,19.946,35.638,30.57q8.662,7.947,16.964,16.331c5.526,5.6,10.969,11.3,16.084,17.406a7.943,7.943,0,0,1-9.885,12.078c-6.993-3.807-13.659-8.014-20.242-12.324q-9.851-6.493-19.363-13.4c-12.695-9.2-24.981-18.888-37.016-28.887s-23.884-20.229-35.409-30.852-22.819-21.529-33.456-33.239a8.173,8.173,0,0,1,10.24-12.513",
    transform: "translate(143.21 65.258)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5654",
    "data-name": "Trac\\xE9 5654",
    d: "M372.352,157.065l-13.623,2.072,9.755,8.548s7.7-2.794,8.457-8.041Z",
    transform: "translate(147.26 64.476)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5655",
    "data-name": "Trac\\xE9 5655",
    d: "M353.514,166.336l8.555,6.714,10.452-6.823-11.651-7.694Z",
    transform: "translate(145.119 65.079)",
    fill: "#ffc3bd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6333",
    "data-name": "Groupe 6333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6332",
    "data-name": "Groupe 6332",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5656",
    "data-name": "Trac\\xE9 5656",
    d: "M388.006,178.015h0a17.914,17.914,0,0,1,16.516-11.745H517.431c8.566,0,14.7,6.779,13.707,15.139L501.979,426.2c-1,8.361-8.748,15.139-17.315,15.139h-358.3c-8.566,0-14.7-6.778-13.709-15.139l24.493-205.618c1-8.36,8.748-15.139,17.315-15.139H349.433c16.88,0,32.876-11.376,38.573-27.43",
    transform: "translate(46.202 68.255)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5657",
    "data-name": "Trac\\xE9 5657",
    d: "M117.235,426.6H491.586l21.331-251.889H138.566Z",
    transform: "translate(48.126 71.721)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5658",
    "data-name": "Trac\\xE9 5658",
    d: "M117.235,426.6H491.586l15.435-251.889H138.566Z",
    transform: "translate(48.126 71.721)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5659",
    "data-name": "Trac\\xE9 5659",
    d: "M117.235,428.93H491.586l12.868-259.883H130.1Z",
    transform: "translate(48.126 69.395)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5660",
    "data-name": "Trac\\xE9 5660",
    d: "M117.235,428.93H491.586l5.092-259.883H130.1Z",
    transform: "translate(48.126 69.395)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5661",
    "data-name": "Trac\\xE9 5661",
    d: "M117.235,430.983H491.586l2.23-266.935H119.465Z",
    transform: "translate(48.126 67.342)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5662",
    "data-name": "Trac\\xE9 5662",
    d: "M118.77,429.512H493.12l-7.682-261.881H113.5Z",
    transform: "translate(46.591 68.813)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5663",
    "data-name": "Trac\\xE9 5663",
    d: "M120.469,428.93H494.82L483.709,169.048H109.358Z",
    transform: "translate(44.892 69.395)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5664",
    "data-name": "Trac\\xE9 5664",
    d: "M122.385,427.79H496.735L479.042,171.826H104.691Z",
    transform: "translate(42.976 70.535)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5665",
    "data-name": "Trac\\xE9 5665",
    d: "M123.206,427.151H497.556L477.042,173.381H102.691Z",
    transform: "translate(42.155 71.174)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5666",
    "data-name": "Trac\\xE9 5666",
    d: "M319.28,189.368h0c.245-7.043,5.54-12.034,12.767-12.034H444.956c8.566,0,16.867,6.945,18.54,15.511L508.1,421.286c1.673,8.567-3.916,15.513-12.482,15.513h-358.3c-8.566,0-16.867-6.945-18.54-15.513L82.01,232.985c-1.673-8.566,3.917-15.511,12.483-15.511H289.461c16.88,0,29.245-11.656,29.818-28.106",
    transform: "translate(33.544 72.796)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6331",
    "data-name": "Groupe 6331",
    transform: "translate(115.258 250.13)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6330",
    "data-name": "Groupe 6330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6329",
    "data-name": "Groupe 6329",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5667",
    "data-name": "Trac\\xE9 5667",
    d: "M319.28,189.368h0c.245-7.043,5.54-12.034,12.767-12.034H444.956c8.566,0,16.867,6.945,18.54,15.511L508.1,421.286c1.673,8.567-3.916,15.513-12.482,15.513h-358.3c-8.566,0-16.867-6.945-18.54-15.513L82.01,232.985c-1.673-8.566,3.917-15.511,12.483-15.511H289.461c16.88,0,29.245-11.656,29.818-28.106",
    transform: "translate(-81.714 -177.334)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderImage);
export default __webpack_public_path__ + "static/media/folder-image.ea826905d60605dfcb3aad104943fcf0.svg";
export { ForwardRef as ReactComponent };